module.exports = __webpack_public_path__ + "static/media/pres82.612e29e7.png";